import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';

import { FeatureFlagService } from 'src/app/core/services/feature-flag.service';
import { EFeatureFlag } from 'src/app/core/services/feature-flags-consts';

export function featureFlagActiveGuard(flag: EFeatureFlag): CanMatchFn {
  return async () => {
    const featureFlagService = inject(FeatureFlagService);

    await featureFlagService.whenReady();

    return featureFlagService.getFlag(flag);
  };
}

export function featureFlagInactiveGuard(flag: EFeatureFlag): CanMatchFn {
  return async () => {
    const featureFlagService = inject(FeatureFlagService);

    await featureFlagService.whenReady();

    return !featureFlagService.getFlag(flag);
  };
}
